import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa6f265"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-up-right-from-square" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { ref, withDefaults, watch } from 'vue';


export const EmitsOptions = {
	'onClick' : () => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDEOpenInNewWindow',
  emits: EmitsOptions,
  setup(__props, { emit }) {



function onClick() {
	emit('onClick');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "IDEOpenInNewWindow",
    onClick: onClick
  }, _hoisted_2))
}
}

})